import { forwardRef } from 'react';
import { cn } from '../../helper/classNames';

const CardTitle = forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'text-2xl font-semibold leading-none tracking-tight dark:text-gray-100',
      className,
    )}
    {...props}
  />
));
CardTitle.displayName = 'CardTitle';

export { CardTitle };
